import {AggregatedAiAttributeValue, AiAttributeValueEntry} from "../../domain/VulSourceItem";

export function formatAiAttributeSummaryValue(value: AggregatedAiAttributeValue | undefined): string {
    if (!value?.values || value.values.length === 0) {
        return "";
    }

    // Use the latest entry (last in chronologically sorted array)
    const entry = value.values[value.values.length - 1];

    return formatEntryValue(entry);
}

function formatEntryValue(entry: AiAttributeValueEntry): string {
    if (entry.valueSummary != null) {
        return entry.valueSummary;
    }

    if (entry.valueRating != null) {
        return String(entry.valueRating);
    }

    if (entry.valueText != null) {
        return entry.valueText;
    }

    if (Array.isArray(entry.valueTexts)) {
        return entry.valueTexts.length > 0 ? entry.valueTexts.join(", ") : "[]";
    }

    return "";
}
